import { useEmitLocationChangeEvent } from '@gasbi/shared';
import { Outlet } from 'react-router-dom';

export const AuthGuard = () => {
  useEmitLocationChangeEvent();

  return <Outlet />;
};
